// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaFile } from "./RanaFile";
import {
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
  RanaFileToJSONTyped,
} from "./RanaFile";
import type { Dataset } from "./Dataset";
import {
  DatasetFromJSON,
  DatasetFromJSONTyped,
  DatasetToJSON,
  DatasetToJSONTyped,
} from "./Dataset";
import type { ExtractDatasetInputResolution } from "./ExtractDatasetInputResolution";
import {
  ExtractDatasetInputResolutionFromJSON,
  ExtractDatasetInputResolutionFromJSONTyped,
  ExtractDatasetInputResolutionToJSON,
  ExtractDatasetInputResolutionToJSONTyped,
} from "./ExtractDatasetInputResolution";

/**
 *
 * @export
 * @interface ExtractDatasetInput
 */
export interface ExtractDatasetInput {
  /**
   *
   */
  dataset: Dataset;
  /**
   *
   */
  resolution?: ExtractDatasetInputResolution;
  /**
   *
   */
  studyArea: RanaFile;
}

/**
 * Check if a given object implements the ExtractDatasetInput interface.
 */
export function instanceOfExtractDatasetInput(value: object): value is ExtractDatasetInput {
  if (!("dataset" in value) || value["dataset"] === undefined) return false;
  if (
    (!("studyArea" in (value as Record<string, any>)) &&
      !("study_area" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["studyArea"] === undefined &&
      (value as Record<string, any>)["study_area"] === undefined)
  )
    return false;
  return true;
}

export function ExtractDatasetInputFromJSON(json: any): ExtractDatasetInput {
  return ExtractDatasetInputFromJSONTyped(json, false);
}

export function ExtractDatasetInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ExtractDatasetInput {
  if (json == null) {
    return json;
  }
  return {
    dataset: DatasetFromJSON(json["dataset"]),
    resolution:
      json["resolution"] == null
        ? undefined
        : ExtractDatasetInputResolutionFromJSON(json["resolution"]),
    studyArea: RanaFileFromJSON(json["study_area"]),
  };
}

export function ExtractDatasetInputToJSON(json: any): ExtractDatasetInput {
  return ExtractDatasetInputToJSONTyped(json, false);
}

export function ExtractDatasetInputToJSONTyped(
  value?: ExtractDatasetInput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    dataset: DatasetToJSON(value["dataset"]),
    resolution: ExtractDatasetInputResolutionToJSON(value["resolution"]),
    study_area: RanaFileToJSON(value["studyArea"]),
  };
}
